export const isMobile = () => /Mobi|Android/i.test(window.navigator.userAgent)

export const getWindowSize = () => ({
  width: window.innerWidth,
  height: window.innerHeight
})

export const debounce = (fn, delay = 300) => {
  let timer = null
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => fn(...args), delay)
  }
}



// WEBPACK FOOTER //
// ./src/utils/deviceDetect.js